<div class="alert alert-info">
  <div class="container-fluid">
    <div class="row">
      <div class="col-auto">
        <fa-icon [icon]="['far', 'question-circle']" size="4x">  </fa-icon>
      </div>
      <div class="col">
        <div [innerHTML]="helpHtmlText"></div>
      </div>
      <div class="col-auto">
        <fa-icon [icon]="['far', 'times']" class="close" (click)="helpClicked()">  </fa-icon>
      </div>
    </div>
  </div>
</div>
